import React from 'react';
import {Button} from "@material-ui/core";
import {useSelector} from 'react-redux';
import {applicationSelector} from "../../redux/application";

export default function ButtonAdapter({disabled, ...rest}) {

  const {loader} = useSelector(applicationSelector);

  return (<Button
    color="primary"
    variant="contained"
    disabled={disabled || loader}
    {...rest}
  />)

}